import { Component, OnInit, inject } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { User } from '../../../../../core/models/user/user';
import { StorageService } from '../../../../../core/services/storage/storage.service';
import { UserService } from '../../../../../core/services/user/user.service';
import { AlertService } from '../../../../../core/services/alert/alert.service';
import { EditVersionComponent } from '../edit-version/edit-version.component';

@Component({
    selector: 'app-subscription-info',
    templateUrl: './subscription-info.component.html',
    styleUrls: ['./subscription-info.component.scss'],
    imports: [NgIf, DatePipe, TranslateModule]
})
export class SubscriptionInfoComponent implements OnInit {
  protected activeModal = inject(NgbActiveModal);
  private storageService = inject(StorageService);
  private userService = inject(UserService);
  private alertService = inject(AlertService);


  protected user: User | undefined;
  protected profileEndDate: Date | undefined;
  protected subscriptionAmount: string | undefined;

  ngOnInit(): void {
    this.user = this.storageService.getUser();
    if (this.user?.profileEndDate && this.user.profileEndDate !== 0) {
      this.profileEndDate = new Date(this.user.profileEndDate);
    }
    const activeSub = this.user?.subscriptions?.find((s: any) => !s.deleted);
    this.subscriptionAmount = activeSub?.amount;
  }

  get profileLabel(): string {
    const name = this.user?.profile?.name ?? 'USER';
    const labels: Record<string, string> = {
      USER: 'Standard',
      ESSENTIEL: 'Essentiel',
      PREMIUM: 'Premium',
      PREMIUM_OFFERT: 'Premium Offert',
      PREMIUM_DECOUVERTE: 'Premium Découverte',
      PRO: 'Pro',
      AUTOIMP: 'Standard Auto-Import',
    };
    return labels[name] ?? name;
  }

  get badgeClass(): string {
    const name = this.user?.profile?.name ?? 'USER';
    if (name === 'PRO') return 'bff-pro-badge';
    if (name === 'ESSENTIEL') return 'bff-essentiel-badge';
    if (name.startsWith('PREMIUM')) return 'bff-premium-badge';
    return 'bff-standard-badge';
  }

  get isAnnual(): boolean {
    return this.userService.hasAnnualSubscription(this.user);
  }

  get isMonthly(): boolean {
    return this.userService.hasMonthlySubscription(this.user);
  }

  get isPaid(): boolean {
    return this.isAnnual || this.isMonthly;
  }

  get paymentMode(): string {
    if (this.isAnnual) return 'PayPal Annuel';
    if (this.isMonthly) return 'PayPal Mensuel';
    return '—';
  }

  get tarifLabel(): string {
    if (!this.subscriptionAmount) return 'Gratuit';
    const amount = parseFloat(this.subscriptionAmount);
    if (this.isAnnual) return `${amount.toFixed(2)} €/an`;
    return `${amount.toFixed(2)} €/mois`;
  }

  get hasEndDate(): boolean {
    return !!this.profileEndDate && this.profileEndDate.getTime() > 0;
  }

  openChangeVersion(): void {
    this.activeModal.dismiss();
    this.alertService.openWithContent(EditVersionComponent).result.catch(() => {});
  }
}
